import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'autocomplete',
    standalone: true
})
export class AutocompletePipe implements PipeTransform {
    transform(value: string, prefix?: string | null): string {
        if (prefix != null && prefix !== '') {
            return `${prefix}-${value}`;
        }
        return value ?? '';
    }
}
